<template>
  <PublicPopup
    ref="PopupRef"
    :padding="15"
    close-type="manual"
    close-placement="top-right"
    @close="handleEmitClose"
    @manual-close="handleEmitManualClose"
  >
    <template #content>
      <div class="registr-greetings-popup">
        <div class="header-container chxy-column-c-c">
          <div class="icon-checked-box chxy-row-c-c">
            <van-icon name="passed" class="icon" />
          </div>
          <div class="icon-cheers-box chxy-row-bt">
            <img class="icon left" :src="getImageUrlWithCDN_TEST('/baixe/icon_cheers.png')" />
            <span class="content">{{ $t('download-popup-registr-greetings-popup.title') }}</span>
            <img class="icon right" :src="getImageUrlWithCDN_TEST('/baixe/icon_cheers.png')" />
          </div>
          <span class="greetings-content">
            {{ $t('download-popup-registr-greetings-popup.line1') }}
            <br />
            {{ $t('download-popup-registr-greetings-popup.line2') }}
            <br />
            {{ $t('download-popup-registr-greetings-popup.line3') }}
          </span>
        </div>

        <InstallButtonsReg
          ref="InstallButtonsRegRef"
          @download="handleDownload"
          @deposite="handleDeposite"
        />
      </div>
    </template>
  </PublicPopup>

  <DownloadGuidePopup ref="DownloadGuidePopupRef" />
</template>

<script setup>
const PopupRef = ref(null)
const InstallButtonsRegRef = ref(null)

// 下载pwa的前置弹窗
const open = () => {
  nextTick(() => {
    PopupRef.value.open()

    const installPrompt = window.deferredPrompt
    if (installPrompt) {
      nextTick(() => {
        InstallButtonsRegRef.value.init(installPrompt)
      })
    }
  })
}
const close = () => {
  PopupRef.value.close()
}
const handleEmitClose = () => {
  emit('close')
}

const manualClose = () => {
  PopupRef.value.manualClose()
}
const handleEmitManualClose = () => {
  emit('manualClose')
}

/**
 * 下载引导弹窗
 */
const DownloadGuidePopupRef = ref(null)
const handleDownloadGuidePopupOpen = () => {
  nextTick(() => {
    DownloadGuidePopupRef.value.open()
  })
}

const handleDownload = (isIos) => {
  emit('download')
  manualClose()
}
const handleDeposite = () => {
  emit('deposite')
  close()
}

const emit = defineEmits(['close', 'manualClose', 'download', 'deposite'])

defineExpose({ open })
</script>

<style scoped lang="scss">
.registr-greetings-popup {
  .header-container {
    margin-bottom: 30px;
    gap: 10px;

    .icon-checked-box {
      .icon {
        font-size: 32px;
        color: var(--reg-greetings-popup-header-checked-icon);
      }
    }

    .icon-cheers-box {
      width: 100%;

      .content {
        width: 75%;
        font-size: 20px;
        // font-weight: 700;
        text-align: center;
        color: var(--reg-greetings-popup-header-title);
        line-height: 1.2;
      }
      .icon {
        width: 24px;

        &.left {
          transform: scaleX(-1);
        }
      }
    }

    .greetings-content {
      font-size: 12px;
      font-family: 'Segoe UI';
      text-align: center;
      color: var(--reg-greetings-popup-header-content);
      line-height: 1.8;
    }
  }
}
</style>
